import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@headlessui/react';

import Modal from '../../widgets/Modal';
import Button from '../../widgets/Button';

import useLogout from '../../../utilities/common/hooks/useLogout';
import { useMfaModalContext } from '../../../shared/providers/MfaModalProvider';

import mfaVisual from '../../../assets/icons/mfa/mfa-visuals.png';

interface ILogoutModalProps {
  open: boolean;
}

function LogoutModal({ open }: ILogoutModalProps) {
  const { logout } = useLogout();
  const { setLogoutModal } = useMfaModalContext();
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      closeButton
      modalClassName="max-w-[450px]"
      handleClose={() => setLogoutModal(false)}
    >
      <div className="mt-[51px] grid justify-center px-6 text-center">
        <img
          src={mfaVisual}
          className="m-auto mb-[26.66px] w-[214px]"
          alt="Mfa visuals"
        />
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('ARE_YOU_SURE')}
        </DialogTitle>
        <span className="text-black-600 mb-[44px] text-sm">
          {t('LOGOUT_ALERT_MESSAGE')}
        </span>
        <Button size="lg" onClick={logout}>
          {t('logout')}
        </Button>
      </div>
    </Modal>
  );
}

export default LogoutModal;
